var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderTabShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3753px",
    height: "72px",
    viewBox: "0 0 3753 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HeaderTabShape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HeaderTabShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.6761814 C6.2142029,24.2746393 9.8549298,26.3297856 10.9221806,29.8416202 C12.5230568,35.1093721 12.5230568,52.4471634 12.5230568,58.4134275 C12.5230568,64.3796915 15.3015559,70.4573533 26.8416851,70.9239851 C34.5351046,71.2350729 84.6075945,71.079529 177.059155,70.4573533 C184.752574,70.7684412 188.599284,66.7537992 188.599284,58.4134275 C188.599284,50.0730557 188.707737,36.688234 188.924642,18.2589624 C189.92471,11.252335 193.797333,7.67929472 200.542512,7.53984156 C207.28769,7.4003884 1391.44019,7.47011498 3753,7.7490213 L3753,0 L0,0.07952899 L0,23.6761814 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.6761814 C6.2142029,24.2746393 9.8549298,26.3297856 10.9221806,29.8416202 C12.5230568,35.1093721 12.5230568,52.4471634 12.5230568,58.4134275 C12.5230568,64.3796915 15.3015559,70.4573533 26.8416851,70.9239851 C34.5351046,71.2350729 84.6075945,71.079529 177.059155,70.4573533 C184.752574,70.7684412 188.599284,66.7537992 188.599284,58.4134275 C188.599284,50.0730557 188.707737,36.688234 188.924642,18.2589624 C189.92471,11.252335 193.797333,7.67929472 200.542512,7.53984156 C207.28769,7.4003884 1391.44019,7.47011498 3753,7.7490213 L3753,0 L0,0 L0,23.6761814 Z",
    id: "path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTabShape);
export default __webpack_public_path__ + "static/media/HeaderTabShape.5eca781311cb3484c4ba93141c0171c5.svg";
export { ForwardRef as ReactComponent };